import clsx from 'clsx';
import React from 'react';
import { Loader } from 'tt-ui-lib/core';
import styles from './CoverLoader.module.scss';

const CoverLoader = ({ loading, ...restProps }) => (
  <div className={clsx(styles.container, !loading ? styles.closed : '')} {...restProps}>
    <Loader />
  </div>
);

export default CoverLoader;
